<template>
    <!-- 保單卡片 -->
    <div
        class="policy-card"
        :class="{'disabled':disabled, 'cursor-pointer':cursorPointer }"
    >
        <!-- title -->
        <div class="title text-white h4 align-top font-semibold -mb-0.5 pt-2.5 py-1.5 pl-2.5 relative rounded-t">
            <slot name="title">
                {{ title }}
            </slot>
            <button
                v-if="!disabled || arrowShow"
                class="inline-block absolute top-1.5 xs:top-2 right-2 transition duration-200"
                :class="[{'-rotate-90':isFold}, arrowShowStyle]"
                @click.stop="foldCard"
            >
                <SvgIcon
                    icon-name="expand_more"
                    class="text-white w-7 h-7 cursor-pointer"
                />
            </button>
            <slot name="tag">
                <div
                    v-if="disabled && tagText"
                    class="absolute top-0 right-2.5 py-1 px-2.5 bg-gray-400 text-sm text-center leading-snug"
                >
                    {{ tagText.substring(0, 2) }}<br>{{ tagText.substring(2) }}
                </div>
            </slot>
        </div>
        <!-- content -->
        <div
            class="content divide-y divide-dashed rounded-b transition-all duraion-200 overflow-hidden md:shadow-3"
            :class="{'ring-secondary ring-2':isActive}"
        >
            <slot name="topContent" />
            <transition name="expand">
                <div
                    v-show="!isFold"
                    class="foldContent divide-y divide-dashed"
                >
                    <slot name="foldContent" />
                </div>
            </transition>
            <slot name="bottomContent" />
        </div>
    </div>
</template>

<script>
import { ref, watchEffect, onMounted } from 'vue';
import { useEventListener } from '@vueuse/core';
import { EUDC } from '@/utils/EUDC';

export default {
    name: 'CardPolicy',
    props: {
        title: {
            type: String,
            default: ''
        },
        tagText: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        cursorPointer: {
            type: Boolean,
            default: true
        },
        // 選取時有綠框框
        isActive: {
            type: Boolean,
            default: false
        },
        arrowShowStyle: {
            type: String,
            default: 'pad:hidden',
        },
        // 右上方的展開按鈕一定要出現
        arrowShow: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const isFold = ref(true);
        const windowWidth = ref(window.innerWidth);
        EUDC();
        const foldCard = () => {
            // if (!props.disabled && windowWidth.value < 768) isFold.value = !isFold.value;
            isFold.value = !isFold.value;
        };

        onMounted(() => {
            useEventListener(window, 'resize', (evt) => {
                windowWidth.value = window.innerWidth;
            });
        });

        watchEffect(() => {
            if (props.arrowShow) {
                isFold.value = true;
            } else if (props.disabled) {
                isFold.value = false;
            } else {
                isFold.value = windowWidth.value < 768;
            }
        });
        return {
            isFold,
            foldCard
        };
    },
};
</script>

<style lang="scss" scoped>
.expand-leave-active,
.expand-enter-active {
    transition: max-height 0.2s linear;
}
.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    overflow: hidden;
}

.expand-enter-to,
.expand-leave-from {
    max-height: 200px;
    overflow: hidden;
}

.policy-card {
    &:not(.disabled) {
        // @apply cursor-pointer;
        .title {
            @apply gradient-primary;
        }
        .content {
            @apply bg-white divide-gray-400 ring-1 ring-gray-200 ring-inset;
            .foldContent {
                @apply divide-gray-400;
            }
        }
        &:hover {
            .content {
                @apply lg:ring-secondary lg:ring-2;
            }
        }
    }
    &.disabled {
        @apply cursor-not-allowed;
        .title {
            @apply bg-gray-200;
        }
        .content {
            @apply bg-gray-50 divide-gray-200 ring-1 ring-gray-200 ring-inset;
            .foldContent {
                @apply divide-gray-200;
            }
        }
    }
}
</style>
